import palette from '@lib/core/src/theme/palette';
import { Button, Stack, TextField, Typography, styled } from '@mui/material';

export const ModalContainer = styled(Stack)(({ theme }) => ({
  padding: '16px',
  borderRadius: '16px',
  background: theme.palette.background.paper
}));

export const ModalTitle = styled(Typography)(({ theme }) => ({
  fontSize: '24px',
  lineHeight: '32px',
  fontWeight: 600,
  color: theme.palette.text.primary
}));

export const ModalDescription = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.text.secondary,
  gap: '6px',
  display: 'flex',
  flexDirection: 'column'
}));

export const StyledTextField = styled(TextField)({
  display: 'flex',
  '& .MuiInputBase-root': {
    borderRadius: 12
  }
});

export const ModalActions = styled(Stack)(({ theme }) => ({
  paddingTop: '12px'
}));

export const StyledCancelButton = styled(Button)(({ theme }) => ({
  borderRadius: 24,
  padding: '6px 50px',
  fontWeight: 500,
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.grey[100],
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.palette.grey[200]
  }
}));

export const StyledSubmitButton = styled(Button)(({ theme }) => ({
  borderRadius: 24,
  padding: '6px 50px',
  fontWeight: 500,
  textTransform: 'none',
  backgroundColor: '#333',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#000'
  },
  '&:disabled': {
    backgroundColor: palette.grey[400],
    color: palette.white
  }
}));
export const StyledTextFieldWrapper = styled(Stack)({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  marginTop: '20px'
});

export const StyledInputLabel = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 500,
  color: theme.palette.grey[500]
}));

export const StyledTextFieldBase = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    borderRadius: 12
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.divider
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.text.primary
  }
}));
